export const NewsRecipe = {
    $type$: 'Recipe',
    name: 'News',
    rule: [
        {
            itemprop: 'content',
            itemtype: { type: 'string' }
        }
    ]
};
const NewsRecipes = [NewsRecipe];
export default NewsRecipes;
//# sourceMappingURL=NewsRecipes.js.map